export default function TweenTransformer(t){
	t.waitE = function(num){ return t.wait(parseInt(num/2)); }
	t.toE = function(obj,num){ return t.to(obj,num?parseInt(num/2):null);}
	return t;
}